<div *ngIf="previewData">
  <h5 class="text-primary fw-semibold mb-1">{{previewData.displayName}}</h5>
  <div>
    <strong>Name:&nbsp;</strong> <span class="fw-semibold">{{previewData.templateName}}</span>
  </div>
  <div>
    <strong>Description:&nbsp;</strong> <span class="fw-semibold">{{previewData.templateDescription}}</span>
  </div>
</div>
